import { i18n } from "utils/util";

export default {
  install(Vue, options = {}) {
    Vue.directive("bgImg", {
      inserted: (el, { value }) => {
        el.style.backgroundImage = `url(${i18n(value)})`;
      },
      update: (el, { value }) => {
        el.style.backgroundImage = `url(${i18n(value)})`;
      },
    });
  },
};
